	<script>
		import { onMount } from 'svelte';
		import ShowerCostApp from './ShowerCostApp';
		const showerCost = new ShowerCostApp();


		let numShowers = 5;
		let showerTimeMins = 25;
		let showerTimerMins = 6;
		let showerData; 
		let totalPerDay;
		let total;
		let totalWithShowerTimer;
		let saving;

		let costPerMinuteShower;
		
		onMount(async () => {
			const res = await fetch(`https://www.showertimer.com.au/wp-json/calculator/v1/data`);
			showerData = await res.json();
			showerCost.setData(showerData);
			costPerMinuteShower = showerCost.totalCostPerOneMinuteShower();
		});

		function calculate() {
			let dailyTotalCents  = numShowers * showerTimeMins * costPerMinuteShower;
			total = ((Math.round(dailyTotalCents) * 365)/100).toFixed(2);

			let dailyTotalWithShowerTimerCents  = numShowers * 6 * costPerMinuteShower;
			totalWithShowerTimer =  ((Math.round(dailyTotalWithShowerTimerCents) * 365)/100).toFixed(2);

			let dailySavingCents = dailyTotalCents - dailyTotalWithShowerTimerCents;

			saving =  ((Math.round(dailySavingCents) * 365)/100).toFixed(2);
		}

	</script>

	<style>
		input[type="number"] {
			max-width: 50px;
			margin-right: .5em;
			flex: 0 0 4em;
			border: 1px solid #dde;
			padding: 2px;

		}

		input[type="number"]:focus {
			background-color: #e2f2ff;
		}

		input[type="range"] {
			flex: 1 1 auto;
			max-width: 70%;
		}

		.control-title {
			font-weight: bold;
			color: #000;
		}

		.controls {
			display: flex;
			justify-content: flex-start;
			max-width: 100%;

		}

		.results {
			text-align: left;
		}

		strong {
			font-weight: bold;
			color: #000;
		}

	</style>

	<p class="control-title">
		Number of minutes per shower:
	</p>

	<div class="controls">
		<input type=number bind:value={showerTimeMins} on:change={calculate} min=7 max=30>
		<input type=range class="calcWidget-range" bind:value={showerTimeMins} on:change={calculate} min=7 max=30>
	</div>

	<p class="control-title">
		Number of showers a day:
	</p>

	<div class="controls">
		<input type=number bind:value={numShowers} on:change={calculate} min=1 max=20>
		<input type=range class="calcWidget-range" bind:value={numShowers} on:change={calculate} min=1 max=20>
	</div>

	{#if total}
		<div class="results">
			<p>You save ${saving} per annum<sup>*</sup></p>
			<p>Total cost per annum <strong>without a shower timer</strong>:  ${total}</p>
			<p>Total cost per annum <strong>with a shower timer</strong>: ${totalWithShowerTimer}</p>
		</div>

		<div class="detail">
			<p>
				<sup>*</sup>Calculation based on a Shower Timer set to {showerData.showertimerDuration} minutes shower duration
				with water heated to {showerData.warmWaterTemp}&deg;C at a flow rate of {showerData.showerFlowRate} litres per minute.
			</p>
		</div>
	{/if}
